export default __webpack_public_path__ + "static/media/errorMB.ac2e07c0.png";